<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0M7.5 10a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0M15.5 8.5a1 1 0 1 0 2 0a1 1 0 1 0-2 0M11 16.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0" />
  </svg>
</template>

<script>
export default { name: 'Moon' };
</script>
